// import React, { useState, useEffect } from 'react';
// import { Link, useNavigate, useLocation } from 'react-router-dom';
// import './checkout.scss';
// import FurnitureNavbar from '../../../../components/layout/Nav';
// import withAuth from '../../../auth/WithAuth';
// import { serverUrlAuth } from '../../../../serverUrl';
// import { toast } from 'react-toastify';

// const CheckoutPage = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const locationState = location.state || {};
//   const selectedItemIds = locationState.selectedItems || [];

//   const [loading, setLoading] = useState(true);
//   const [processingPayment, setProcessingPayment] = useState(false);
//   const [selectedCartItems, setSelectedCartItems] = useState([]);
//   const [userProfile, setUserProfile] = useState(null);

//   // Form state
//   const [formData, setFormData] = useState({
//     shipping_address: '',
//     phone_number: '',
//   });

//   // Form errors
//   const [errors, setErrors] = useState({});

//   // Redirect if no items selected
//   useEffect(() => {
//     if (!selectedItemIds || selectedItemIds.length === 0) {
//       toast.warning('Please select items to checkout');
//       navigate('/cart');
//     }
//   }, [selectedItemIds, navigate]);

//   // Fetch cart and user profile on mount
//   useEffect(() => {
//     if (selectedItemIds?.length) {
//       fetchCart();
//       fetchUserProfile();
//     }
//   }, []);

//   const fetchCart = async () => {
//     try {
//       setLoading(true);
//       const response = await serverUrlAuth.get('cart/');
//       console.log('Cart response:', response.data);

//       const cartData = response.data;
//       const cartItemsArray = cartData.items || [];

//       // Filter only selected items - using the CartItem IDs
//       const filteredItems = cartItemsArray
//         .filter((item) => selectedItemIds.includes(item.id))
//         .map((item) => ({
//           id: item.id, // This is the CartItem ID
//           cartItemId: item.id, // Explicitly store CartItem ID
//           productId: item.product?.id,
//           variantId: item.variant?.id,
//           name: item.product?.name || 'Product',
//           // Use variant price
//           unitPrice: parseFloat(item.unit_price || item.variant?.selling_price || 0),
//           originalPrice: parseFloat(item.variant?.original_price || 0),
//           quantity: item.quantity,
//           colorName: item.variant?.color_name || 'Default',
//           colorCode: item.variant?.color_code || '#000000',
//           image: item.variant?.images?.[0]?.image ||
//                  item.product?.images?.[0]?.image ||
//                  'https://via.placeholder.com/50x50?text=No+Image',
//           inStock: (item.variant?.stock || 0) > 0,
//           stockCount: item.variant?.stock || 0,
//           variant: item.variant,
//           product: item.product,
//           // Store full item for reference
//           rawItem: item,
//         }));

//       console.log('Selected items for checkout:', filteredItems);
//       setSelectedCartItems(filteredItems);
//     } catch (error) {
//       console.error('Error fetching cart:', error);
//       toast.error('Failed to load selected items');
//       navigate('/cart');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchUserProfile = async () => {
//     try {
//       const response = await serverUrlAuth.get('users/address-details/');
//       console.log('User profile:', response.data);
//       setUserProfile(response.data);

//       if (response.data.last_shipping_address) {
//         setFormData((prev) => ({
//           ...prev,
//           shipping_address: response.data.last_shipping_address || '',
//           phone_number: response.data.last_phone_number || '',
//         }));
//       }
//     } catch (error) {
//       console.error('Error fetching profile:', error);
//     }
//   };

//   // Calculate totals
//   const subtotal = selectedCartItems.reduce(
//     (sum, item) => sum + item.unitPrice * item.quantity,
//     0,
//   );
//   const vat = subtotal * 0.16;
//   const total = subtotal + vat;

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({
//       ...formData,
//       [name]: value,
//     });
//     if (errors[name]) {
//       setErrors({
//         ...errors,
//         [name]: '',
//       });
//     }
//   };

//   const validateForm = () => {
//     const newErrors = {};

//     if (!formData.shipping_address.trim()) {
//       newErrors.shipping_address = 'Shipping address is required';
//     }
//     if (!formData.phone_number.trim()) {
//       newErrors.phone_number = 'Phone number is required';
//     } else if (
//       !/^(\+?\d{1,3}[-.]?)?\d{10}$/.test(
//         formData.phone_number.replace(/\s/g, ''),
//       )
//     ) {
//       newErrors.phone_number = 'Please enter a valid phone number';
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleCheckout = async () => {
//     if (!validateForm()) {
//       toast.error('Please fill in all required fields');
//       return;
//     }

//     if (selectedCartItems.length === 0) {
//       toast.error('No items selected for checkout');
//       return;
//     }

//     setProcessingPayment(true);

//     try {
//       // Send the CartItem IDs (not variant IDs)
//       const cartItemIds = selectedCartItems.map(item => item.cartItemId || item.id);

//       console.log('Sending cart item IDs:', cartItemIds);

//       const response = await serverUrlAuth.post('checkout/', {
//         cart_items: cartItemIds,
//         shipping_address: formData.shipping_address,
//         phone_number: formData.phone_number,
//       });

//       console.log('Checkout response:', response.data);

//       if (response.status === 201 && response.data.payment?.authorization_url) {
//         toast.info('Redirecting to payment gateway...');
//         window.location.href = response.data.payment.authorization_url;
//       } else {
//         toast.error('Checkout failed: ' + (response.data.error || 'Unknown error'));
//         setProcessingPayment(false);
//       }
//     } catch (error) {
//       console.error('Checkout error:', error);
//       const errorMessage = error.response?.data?.error || 'Failed to process checkout. Please try again.';
//       toast.error(errorMessage);
//       setProcessingPayment(false);
//     }
//   };

//   if (loading) {
//     return (
//       <>
//         <FurnitureNavbar />
//         <div className="checkout-page">
//           <div className="checkout-loading">
//             <div className="spinner"></div>
//             <p>Loading checkout...</p>
//           </div>
//         </div>
//       </>
//     );
//   }

//   if (selectedCartItems.length === 0) {
//     return (
//       <>
//         <FurnitureNavbar />
//         <div className="checkout-page">
//           <div className="empty-checkout">
//             <div className="empty-icon">📦</div>
//             <h2>No items selected</h2>
//             <p>
//               Please select items from your cart before proceeding to checkout
//             </p>
//             <Link to="/cart" className="back-to-cart-btn">
//               <svg viewBox="0 0 24 24">
//                 <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
//               </svg>
//               Back to Cart
//             </Link>
//           </div>
//         </div>
//       </>
//     );
//   }

//   // Format currency helper
//   const formatCurrency = (amount) => {
//     if (!amount || amount === 0) return 'KSh 0';
//     return `KSh ${parseFloat(amount).toLocaleString()}`;
//   };

//   return (
//     <>
//       <FurnitureNavbar />
//       <div className="checkout-page">
//         <div className="checkout-container">
//           {/* Header */}
//           <div className="checkout-header">
//             <Link to="/cart" className="back-link">
//               <svg viewBox="0 0 24 24">
//                 <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
//               </svg>
//               Back to Cart
//             </Link>
//             <h1>Checkout</h1>
//           </div>

//           <div className="checkout-content">
//             {/* Left Column - Forms */}
//             <div className="checkout-forms">
//               {/* Shipping Information */}
//               <div className="form-section">
//                 <h2>Shipping Information</h2>

//                 <div className="form-group">
//                   <label>Shipping Address *</label>
//                   <textarea
//                     name="shipping_address"
//                     value={formData.shipping_address}
//                     onChange={handleInputChange}
//                     className={errors.shipping_address ? 'error' : ''}
//                     placeholder="Enter your full shipping address"
//                     rows="4"
//                   />
//                   {errors.shipping_address && (
//                     <span className="error-message">
//                       {errors.shipping_address}
//                     </span>
//                   )}
//                   <small className="hint">
//                     Include street address, city, state, and postal code
//                   </small>
//                 </div>

//                 <div className="form-group">
//                   <label>Phone Number *</label>
//                   <input
//                     type="tel"
//                     name="phone_number"
//                     value={formData.phone_number}
//                     onChange={handleInputChange}
//                     className={errors.phone_number ? 'error' : ''}
//                     placeholder="e.g., 0712 345 678"
//                   />
//                   {errors.phone_number && (
//                     <span className="error-message">{errors.phone_number}</span>
//                   )}
//                   <small className="hint">
//                     We'll use this to contact you about your order
//                   </small>
//                 </div>
//               </div>

//               {/* Order Summary inline for mobile */}
//               <div className="form-section mobile-summary">
//                 <h2>Order Summary</h2>
//                 {selectedCartItems.map((item) => (
//                   <div key={item.id} className="summary-item-mobile">
//                     <div className="item-info">
//                       <span className="item-name">{item.name}</span>
//                       {item.colorName && (
//                         <span className="item-color">
//                           <span
//                             className="color-dot"
//                             style={{ backgroundColor: item.colorCode || '#ccc' }}
//                           />
//                           {item.colorName}
//                         </span>
//                       )}
//                       <span className="item-qty">Qty: {item.quantity}</span>
//                     </div>
//                     <span className="item-price">
//                       {formatCurrency(item.unitPrice * item.quantity)}
//                     </span>
//                   </div>
//                 ))}
//               </div>
//             </div>

//             {/* Right Column - Order Summary */}
//             <div className="order-summary">
//               <h2>Order Summary</h2>

//               <div className="items-list">
//                 {selectedCartItems.map((item) => (
//                   <div key={item.id} className="summary-item">
//                     <div className="item-image">
//                       {typeof item.image === 'string' &&
//                       item.image.startsWith('http') ? (
//                         <img src={item.image} alt={item.name} />
//                       ) : (
//                         <span>🛒</span>
//                       )}
//                     </div>
//                     <div className="item-details">
//                       <h4>{item.name}</h4>
//                       {item.colorName && (
//                         <div className="variant-info">
//                           <span
//                             className="color-swatch"
//                             style={{ backgroundColor: item.colorCode || '#ccc' }}
//                           />
//                           <span className="color-name">{item.colorName}</span>
//                         </div>
//                       )}
//                       <span className="item-quantity">Qty: {item.quantity}</span>
//                     </div>
//                     <div className="item-price">
//                       {formatCurrency(item.unitPrice * item.quantity)}
//                     </div>
//                   </div>
//                 ))}
//               </div>

//               <div className="summary-calculations">
//                 <div className="summary-row">
//                   <span>Subtotal ({selectedCartItems.length} items)</span>
//                   <span>{formatCurrency(subtotal)}</span>
//                 </div>
//                 <div className="summary-row">
//                   <span>VAT (16%)</span>
//                   <span>{formatCurrency(vat)}</span>
//                 </div>
//                 <div className="summary-row total">
//                   <span>Total</span>
//                   <span>{formatCurrency(total)}</span>
//                 </div>
//               </div>

//               <button
//                 className="payment-btn"
//                 onClick={handleCheckout}
//                 disabled={processingPayment}
//               >
//                 {processingPayment ? (
//                   <>
//                     <span className="spinner-small"></span>
//                     Processing...
//                   </>
//                 ) : (
//                   <>Proceed to Payment ({formatCurrency(total)})</>
//                 )}
//               </button>

//               <p className="terms-notice">
//                 By proceeding, you agree to our{' '}
//                 <Link to="/terms">Terms of Service</Link> and{' '}
//                 <Link to="/privacy">Privacy Policy</Link>
//               </p>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Loading overlay */}
//       {processingPayment && (
//         <div className="payment-overlay">
//           <div className="payment-loading">
//             <div className="spinner-large"></div>
//             <h3>Processing your payment...</h3>
//             <p>Please wait while we redirect you to the payment gateway</p>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default withAuth(CheckoutPage, 'client');

// src/pages/client/Checkout/CheckoutPage.jsx
import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import './checkout.scss';
import Sidebar from '../../../../components/layout/Sidebar';
import withAuth from '../../../auth/WithAuth';
import { serverUrlAuth } from '../../../../serverUrl';
import { toast } from 'react-toastify';
import {
  FaArrowLeft,
  FaLock,
  FaMapMarkerAlt,
  FaPhone,
  FaShoppingBag,
  FaCheckCircle,
} from 'react-icons/fa';

const CheckoutPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const locationState = location.state || {};
  const selectedItemIds = locationState.selectedItems || [];

  const [loading, setLoading] = useState(true);
  const [processingPayment, setProcessingPayment] = useState(false);
  const [selectedCartItems, setSelectedCartItems] = useState([]);
  const [userProfile, setUserProfile] = useState(null);

  const [formData, setFormData] = useState({
    shipping_address: '',
    phone_number: '',
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (!selectedItemIds || selectedItemIds.length === 0) {
      toast.warning('Please select items to checkout');
      navigate('/cart');
    }
  }, [selectedItemIds, navigate]);

  useEffect(() => {
    if (selectedItemIds?.length) {
      fetchCart();
      fetchUserProfile();
    }
  }, []);

  const fetchCart = async () => {
    try {
      setLoading(true);
      const response = await serverUrlAuth.get('cart/');
      const cartData = response.data;
      const cartItemsArray = cartData.items || [];

      const filteredItems = cartItemsArray
        .filter((item) => selectedItemIds.includes(item.id))
        .map((item) => ({
          id: item.id,
          cartItemId: item.id,
          productId: item.product?.id,
          variantId: item.variant?.id,
          name: item.product?.name || 'Product',
          unitPrice: parseFloat(
            item.unit_price || item.variant?.selling_price || 0,
          ),
          originalPrice: parseFloat(item.variant?.original_price || 0),
          quantity: item.quantity,
          colorName: item.variant?.color_name || 'Default',
          colorCode: item.variant?.color_code || '#000000',
          image:
            item.variant?.images?.[0]?.image ||
            item.product?.images?.[0]?.image ||
            'https://via.placeholder.com/50x50?text=No+Image',
          inStock: (item.variant?.stock || 0) > 0,
          stockCount: item.variant?.stock || 0,
          variant: item.variant,
          product: item.product,
          rawItem: item,
        }));

      setSelectedCartItems(filteredItems);
    } catch (error) {
      console.error('Error fetching cart:', error);
      toast.error('Failed to load selected items');
      navigate('/cart');
    } finally {
      setLoading(false);
    }
  };

  const fetchUserProfile = async () => {
    try {
      const response = await serverUrlAuth.get('users/address-details/');
      setUserProfile(response.data);

      if (response.data.last_shipping_address) {
        setFormData((prev) => ({
          ...prev,
          shipping_address: response.data.last_shipping_address || '',
          phone_number: response.data.last_phone_number || '',
        }));
      }
    } catch (error) {
      console.error('Error fetching profile:', error);
    }
  };

  const subtotal = selectedCartItems.reduce(
    (sum, item) => sum + item.unitPrice * item.quantity,
    0,
  );
  const vat = subtotal * 0.16;
  const total = subtotal + vat;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    if (errors[name]) setErrors({ ...errors, [name]: '' });
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.shipping_address.trim()) {
      newErrors.shipping_address = 'Shipping address is required';
    }
    if (!formData.phone_number.trim()) {
      newErrors.phone_number = 'Phone number is required';
    } else if (
      !/^(\+?\d{1,3}[-.]?)?\d{10}$/.test(
        formData.phone_number.replace(/\s/g, ''),
      )
    ) {
      newErrors.phone_number = 'Please enter a valid phone number';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleCheckout = async () => {
    if (!validateForm()) {
      toast.error('Please fill in all required fields');
      return;
    }
    if (selectedCartItems.length === 0) {
      toast.error('No items selected for checkout');
      return;
    }

    setProcessingPayment(true);

    try {
      const cartItemIds = selectedCartItems.map(
        (item) => item.cartItemId || item.id,
      );

      const response = await serverUrlAuth.post('checkout/', {
        cart_items: cartItemIds,
        shipping_address: formData.shipping_address,
        phone_number: formData.phone_number,
      });

      if (response.status === 201 && response.data.payment?.authorization_url) {
        toast.info('Redirecting to payment gateway...');
        window.location.href = response.data.payment.authorization_url;
      } else {
        toast.error(
          'Checkout failed: ' + (response.data.error || 'Unknown error'),
        );
        setProcessingPayment(false);
      }
    } catch (error) {
      console.error('Checkout error:', error);
      const errorMessage =
        error.response?.data?.error ||
        'Failed to process checkout. Please try again.';
      toast.error(errorMessage);
      setProcessingPayment(false);
    }
  };

  const formatCurrency = (amount) => {
    if (!amount || amount === 0) return 'KSh 0';
    return `KSh ${parseFloat(amount).toLocaleString()}`;
  };

  return (
    <>
      <Sidebar />
      <div className="modern-dashboard checkout-shell">
        <div className="checkout-page">
          {/* Hero */}
          {/* <header className="hero-craftsmanship">
            <div className="hero-pattern"></div>
            <div className="hero-content-modern">
              <div className="welcome-badge">
                <FaCreditCard className="badge-icon" />
                <span>Secure Checkout</span>
              </div>
              <h1 className="hero-title">
                <span className="gradient-text">Almost</span>
                <span className="hero-accent">There</span>
              </h1>
              <p className="hero-subtitle">
                Confirm your shipping details and complete your purchase
                securely.
              </p>
            </div>
          </header> */}

          <div className="checkout-container">
            {loading ? (
              <div className="checkout-loading">
                <div className="spinner"></div>
                <p>Loading checkout...</p>
              </div>
            ) : selectedCartItems.length === 0 ? (
              <div className="empty-checkout">
                <div className="empty-icon">
                  <FaShoppingBag />
                </div>
                <h2>No items selected</h2>
                <p>
                  Please select items from your cart before proceeding to
                  checkout.
                </p>
                <Link to="/cart" className="back-to-cart-btn">
                  <FaArrowLeft />
                  Back to Cart
                </Link>
              </div>
            ) : (
              <>
                <div className="checkout-header">
                  <Link to="/cart" className="back-link">
                    <FaArrowLeft />
                    Back to Cart
                  </Link>
                  <h1>Checkout</h1>
                </div>

                <div className="checkout-content">
                  {/* Left: Forms */}
                  <div className="checkout-forms">
                    <div className="form-section">
                      <h2>
                        <FaMapMarkerAlt /> Shipping Information
                      </h2>

                      <div className="form-group">
                        <label>Shipping Address *</label>
                        <textarea
                          name="shipping_address"
                          value={formData.shipping_address}
                          onChange={handleInputChange}
                          className={errors.shipping_address ? 'error' : ''}
                          placeholder="Enter your full shipping address"
                          rows="4"
                        />
                        {errors.shipping_address && (
                          <span className="error-message">
                            {errors.shipping_address}
                          </span>
                        )}
                        <small className="hint">
                          Include street address, city, state, and postal code
                        </small>
                      </div>

                      <div className="form-group">
                        <label>
                          <FaPhone /> Phone Number *
                        </label>
                        <input
                          type="tel"
                          name="phone_number"
                          value={formData.phone_number}
                          onChange={handleInputChange}
                          className={errors.phone_number ? 'error' : ''}
                          placeholder="e.g., 0712 345 678"
                        />
                        {errors.phone_number && (
                          <span className="error-message">
                            {errors.phone_number}
                          </span>
                        )}
                        <small className="hint">
                          We'll use this to contact you about your order
                        </small>
                      </div>
                    </div>

                    {/* Mobile summary inline */}
                    <div className="form-section mobile-summary">
                      <h2>
                        <FaShoppingBag /> Order Summary
                      </h2>
                      {selectedCartItems.map((item) => (
                        <div key={item.id} className="summary-item-mobile">
                          <div className="item-info">
                            <span className="item-name">{item.name}</span>
                            {item.colorName && (
                              <span className="item-color">
                                <span
                                  className="color-dot"
                                  style={{
                                    backgroundColor: item.colorCode || '#ccc',
                                  }}
                                />
                                {item.colorName}
                              </span>
                            )}
                            <span className="item-qty">
                              Qty: {item.quantity}
                            </span>
                          </div>
                          <span className="item-price">
                            {formatCurrency(item.unitPrice * item.quantity)}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Right: Order summary */}
                  <div className="order-summary">
                    <h2>Order Summary</h2>

                    <div className="items-list">
                      {selectedCartItems.map((item) => (
                        <div key={item.id} className="summary-item">
                          <div className="item-image">
                            {typeof item.image === 'string' &&
                            item.image.startsWith('http') ? (
                              <img src={item.image} alt={item.name} />
                            ) : (
                              <FaShoppingBag />
                            )}
                          </div>
                          <div className="item-details">
                            <h4>{item.name}</h4>
                            {item.colorName && (
                              <div className="variant-info">
                                <span
                                  className="color-swatch"
                                  style={{
                                    backgroundColor: item.colorCode || '#ccc',
                                  }}
                                />
                                <span className="color-name">
                                  {item.colorName}
                                </span>
                              </div>
                            )}
                            <span className="item-quantity">
                              Qty: {item.quantity}
                            </span>
                          </div>
                          <div className="item-price">
                            {formatCurrency(item.unitPrice * item.quantity)}
                          </div>
                        </div>
                      ))}
                    </div>

                    {/* <div className="summary-calculations">
                      <div className="summary-row">
                        <span>
                          Subtotal ({selectedCartItems.length} items)
                        </span>
                        <span>{formatCurrency(subtotal)}</span>
                      </div>
                      <div className="summary-row">
                        <span>VAT (16%)</span>
                        <span>{formatCurrency(vat)}</span>
                      </div>
                      <div className="summary-row total">
                        <span>Total</span>
                        <span>{formatCurrency(total)}</span>
                      </div>
                    </div> */}
                    <div className="summary-calculations">
                      <div className="summary-row">
                        <span>Subtotal ({selectedCartItems.length} items)</span>
                        <span>{formatCurrency(subtotal)}</span>
                      </div>

                      <div className="summary-row">
                        <span>VAT (16%)</span>
                        <span>{formatCurrency(vat)}</span>
                      </div>

                      {/* ✅ Delivery note row */}
                      <div className="summary-row delivery-note-row">
                        <span>Delivery</span>
                        <span className="delivery-note-value">
                          Charged separately
                        </span>
                      </div>

                      <div className="summary-row total">
                        <span>Total</span>
                        <span>{formatCurrency(total)}</span>
                      </div>

                      {/* ✅ Expanded explanation */}
                      <div className="delivery-disclaimer">
                        <span className="disclaimer-icon">🚚</span>

                        <p>
                          <strong>Delivery is charged separately.</strong> The
                          final delivery fee depends on your location and the
                          courier used, and will be communicated to you after
                          checkout. You'll approve it before dispatch.
                        </p>
                      </div>
                    </div>

                    <button
                      className="payment-btn"
                      onClick={handleCheckout}
                      disabled={processingPayment}
                    >
                      {processingPayment ? (
                        <>
                          <span className="spinner-small"></span>
                          Processing...
                        </>
                      ) : (
                        <>
                          <FaLock />
                          Proceed to Payment ({formatCurrency(total)})
                        </>
                      )}
                    </button>

                    <p className="terms-notice">
                      By proceeding, you agree to our{' '}
                      <Link to="/terms">Terms of Service</Link> and{' '}
                      <Link to="/privacy">Privacy Policy</Link>
                    </p>

                   
                  </div>
                </div>
              </>
            )}
          </div>
        </div>

        {/* Payment overlay */}
        {processingPayment && (
          <div className="payment-overlay">
            <div className="payment-loading">
              <div className="spinner-large"></div>
              <h3>Processing your payment...</h3>
              <p>Please wait while we redirect you to the payment gateway</p>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default withAuth(CheckoutPage, 'client');
